import React, { useState } from 'react';
import { Box, TextField, Button, Typography, Radio, RadioGroup, FormControlLabel, FormControl, FormLabel, MenuItem } from '@mui/material';
import InputMask from 'react-input-mask';
import emailjs from 'emailjs-com';

const CotacaoForm = ({ serviceId, templateId, userId, colaborador}) => {
  const currentYear = new Date().getFullYear();
  const [formData, setFormData] = useState({
    nomeCompleto: '',
    cpf: '',
    email: '',
    placaVeiculo: '',
    telefoneCelular: '',
    modeloAnoVeiculo: '',
    indicarOutroCondutor: 'nao',
    principalCondutor: '',
    cpfPrincipalCondutor: '',
    estadoCivil: '',
    cepResidenciaPernoite: '',
    atividadeRemunerada: 'nao',
    residenciaGaragem: 'nao',
    veiculoFaculdade: 'nao',
    pessoas18a26UsamVeiculo: 'nao',
    veiculoTrabalho: 'nao',
    garagemTrabalho: 'nao',
    colaborador: colaborador,
    contatoPreferido: 'mensagem',
  });


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleRadioChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value, 
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const requiredFields = [
      'nomeCompleto',
      'cpf',
      'email',
      'placaVeiculo',
      'modeloAnoVeiculo',
      'estadoCivil',
      'cepResidenciaPernoite',
      'atividadeRemunerada',
      'residenciaGaragem',
      'veiculoFaculdade',
      'pessoas18a26UsamVeiculo',
      'veiculoTrabalho',
      'garagemTrabalho',
      'contatoPreferido',
      'telefoneCelular'

    ];

    const allFieldsFilled = requiredFields.every((field) => formData[field] !== '' && formData[field] !== null);

    if (!allFieldsFilled) {
      alert('Por favor, preencha todos os campos obrigatórios!');
      return;
    }
 emailjs.send(serviceId, templateId, formData, userId)
  .then((result) => {
    console.log('SUCCESS!', result.status, result.text);
    alert('Mensagem enviada com sucesso!');
  }, (error) => {
    console.error('FAILED...', error);
    alert('Erro ao enviar a mensagem, tente novamente.');
  });

    

    setFormData({
      nomeCompleto: '',
      cpf: '',
      email: '',
      placaVeiculo: '',
      modeloAnoVeiculo: '',
      indicarOutroCondutor: 'nao',
      principalCondutor: '',
      cpfPrincipalCondutor: '',
      estadoCivil: '',
      cepResidenciaPernoite: '',
      atividadeRemunerada: 'nao',
      telefoneCelular: '',
      contatoPreferido: 'ligacao',
      residenciaGaragem: 'nao',
      veiculoFaculdade: 'nao',
      pessoas18a26UsamVeiculo: 'nao',
      veiculoTrabalho: 'nao',
      garagemTrabalho: 'nao',
      colaborador: 'pelo site'
    });
    

 
    

  };

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      sx={{
        maxWidth: '500px',
        margin: '0px auto',
        padding: '40px',
        backgroundColor: '#f9f9f9',
        borderRadius: '5%',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        color: '#103874'
      }}
    >
      <Typography 
        variant="h4" 
        gutterBottom 
        textAlign="center" 
        sx={{ fontWeight: 'bold', color: '#103874' }}
      >
        Cote agora mesmo!
      </Typography>
      <Typography variant="body1" gutterBottom textAlign="center" color="textSecondary">
      cote agora em mais de 16 seguradoras
      </Typography>

      {/* Nome Completo */}

      <TextField
        label= "Captado por:"
        name="colaborador"
        value={formData.colaborador}
        fullWidth
        margin="normal"
        InputProps={{
          readOnly: true,
        }}
        disabled
      />

      <TextField
        label="Nome Completo"
        name="nomeCompleto"
        value={formData.nomeCompleto}
        onChange={handleChange}
        fullWidth
        margin="normal"
        required
      />

      {/* CPF */}
      <InputMask
        mask="999.999.999-99"
        value={formData.cpf}
        onChange={handleChange}
      >
        {() => <TextField label="CPF" name="cpf" fullWidth margin="normal" required />}
      </InputMask>

      {/* E-mail */}
      <TextField
        label="E-mail"
        name="email"
        value={formData.email}
        onChange={handleChange}
        fullWidth
        margin="normal"
        required
        type="email"
      />


<InputMask
  mask="(99) 99999-9999"
  value={formData.celular}
  onChange={handleChange}
>
  {() => <TextField label="Celular" name="telefoneCelular" fullWidth margin="normal" required />}
</InputMask>



      {/* Contato Preferido */}
      <FormControl margin="normal" fullWidth>
        <FormLabel>Prefere mensagem ou ligação?</FormLabel>
        <RadioGroup
          row
          name="contatoPreferido"
          value={formData.contatoPreferido}
          onChange={(e) => setFormData({ ...formData, contatoPreferido: e.target.value })}
        >
          <FormControlLabel value="mensagem" control={<Radio />} label="Mensagem" />
          <FormControlLabel value="ligacao" control={<Radio />} label="Ligação" />
        </RadioGroup>
      </FormControl>

      {/* Placa do Veículo */}
      <InputMask
        mask="aaa-9*99"
        value={formData.placaVeiculo}
        onChange={handleChange}
      >
        {() => <TextField label="Placa do Veículo" name="placaVeiculo" fullWidth margin="normal" required />}
      </InputMask>

      {/* Modelo/Ano do Veículo */}
      <TextField
        select
        label="Modelo/Ano do Veículo"
        name="modeloAnoVeiculo"
        value={formData.modeloAnoVeiculo}
        onChange={handleChange}
        fullWidth
        margin="normal"
        required
      >
        {Array.from({ length: currentYear - 1990 + 1 }, (_, i) => 1990 + i).map((year) => (
          <MenuItem key={year} value={year}>
            {year}
          </MenuItem>
        ))}
      </TextField>

      {/* Estado Civil */}
      <TextField
        select
        label="Estado Civil"
        name="estadoCivil"
        value={formData.estadoCivil}
        onChange={handleChange}
        fullWidth
        margin="normal"
        required
      >
        <MenuItem value="casado">Casado</MenuItem>
        <MenuItem value="solteiro">Solteiro</MenuItem>
        <MenuItem value="divorciado">Divorciado</MenuItem>
      </TextField>

      {/* CEP */}
      <InputMask
        mask="99999-999"
        value={formData.cepResidenciaPernoite}
        onChange={handleChange}
      >
        {() => <TextField label="CEP de Residência" name="cepResidenciaPernoite" fullWidth margin="normal" required />}
      </InputMask>

      {/* Indicar Outro Condutor */}
      <FormControl component="fieldset" margin="normal" fullWidth required>
        <FormLabel component="legend">Indicar Outro Condutor?</FormLabel>
        <RadioGroup
          row
          name="indicarOutroCondutor"
          value={formData.indicarOutroCondutor}
          onChange={handleRadioChange}
        >
          <FormControlLabel value="sim" control={<Radio />} label="Sim" />
          <FormControlLabel value="nao" control={<Radio />} label="Não" />
        </RadioGroup>
      </FormControl>

      {formData.indicarOutroCondutor === 'sim' && (
        <>
          <TextField
            label="Principal Condutor"
            name="principalCondutor"
            value={formData.principalCondutor}
            onChange={handleChange}
            fullWidth
            margin="normal"
            required
          />
          <InputMask
            mask="999.999.999-99"
            value={formData.cpfPrincipalCondutor}
            onChange={handleChange}
          >
            {() => <TextField label="CPF do Principal Condutor" name="cpfPrincipalCondutor" fullWidth margin="normal" required />}
          </InputMask>
        </>
      )}

      {/* Atividade Remunerada */}
      <FormControl component="fieldset" margin="normal" fullWidth required>
        <FormLabel component="legend">Atividade Remunerada?</FormLabel>
        <RadioGroup
          row
          name="atividadeRemunerada"
          value={formData.atividadeRemunerada}
          onChange={handleRadioChange}
        >
          <FormControlLabel value="sim" control={<Radio />} label="Sim" />
          <FormControlLabel value="nao" control={<Radio />} label="Não" />
        </RadioGroup>
      </FormControl>

      {/* Garagem na residência */}
      <FormControl component="fieldset" margin="normal" fullWidth required>
        <FormLabel component="legend">Reside em casa com garagem?</FormLabel>
        <RadioGroup
          row
          name="residenciaGaragem"
          value={formData.residenciaGaragem}
          onChange={handleRadioChange}
        >
          <FormControlLabel value="sim" control={<Radio />} label="Sim" />
          <FormControlLabel value="nao" control={<Radio />} label="Não" />
        </RadioGroup>
      </FormControl>

      {/* Veículo usado para faculdade */}
      <FormControl component="fieldset" margin="normal" fullWidth required>
        <FormLabel component="legend">Veículo usado para faculdade?</FormLabel>
        <RadioGroup
          row
          name="veiculoFaculdade"
          value={formData.veiculoFaculdade}
          onChange={handleRadioChange}
        >
          <FormControlLabel value="sim" control={<Radio />} label="Sim" />
          <FormControlLabel value="nao" control={<Radio />} label="Não" />
        </RadioGroup>
      </FormControl>

      {/* Pessoas entre 18 e 26 usam o veículo */}
      <FormControl component="fieldset" margin="normal" fullWidth required>
        <FormLabel component="legend">Pessoas entre 18 e 26 usam o veículo?</FormLabel>
        <RadioGroup
          row
          name="pessoas18a26UsamVeiculo"
          value={formData.pessoas18a26UsamVeiculo}
          onChange={handleRadioChange}
        >
          <FormControlLabel value="sim" control={<Radio />} label="Sim" />
          <FormControlLabel value="nao" control={<Radio />} label="Não" />
        </RadioGroup>
      </FormControl>

      {/* Veículo usado para trabalho */}
      <FormControl component="fieldset" margin="normal" fullWidth required>
        <FormLabel component="legend">Veículo usado para trabalho?</FormLabel>
        <RadioGroup
          row
          name="veiculoTrabalho"
          value={formData.veiculoTrabalho}
          onChange={handleRadioChange}
        >
          <FormControlLabel value="sim" control={<Radio />} label="Sim" />
          <FormControlLabel value="nao" control={<Radio />} label="Não" />
        </RadioGroup>
      </FormControl>

      {/* Garagem no trabalho */}
      <FormControl component="fieldset" margin="normal" fullWidth required>
        <FormLabel component="legend">Tem garagem no trabalho?</FormLabel>
        <RadioGroup
          row
          name="garagemTrabalho"
          value={formData.garagemTrabalho}
          onChange={handleRadioChange}
        >
          <FormControlLabel value="sim" control={<Radio />} label="Sim" />
          <FormControlLabel value="nao" control={<Radio />} label="Não" />
        </RadioGroup>
      </FormControl>

      <Button type="submit" variant="contained" color="primary" fullWidth>
        Enviar
      </Button>
    </Box>
  );
};

export default CotacaoForm;
